import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-testimonials',
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.scss']
})
export class TestimonialsComponent implements OnInit {

  activeStartIndex = 0;

  testimonials = [
    {
      name: 'Rinki',
      role: 'Student',
      text: 'I feel the kind of exposure we got from our institute was phenomenal. The exposure was not only limited to the boundaries of our countries but was global too.',
      image: 'assets/img/testimonials/rinki.jpg'
    },
    {
      name: 'Anisha Kumari',
      role: 'Student',
      text: 'A strong structure can be built on a strong foundation. My years in Vaish College helped carving my foundation and thus I am, and I will always stand the test of time.',
      image: 'assets/img/testimonials/anisha.jpg'
    },
    {
      name: 'Heena',
      role: 'Student',
      text: "The time I spent at Vaish College was enriched and Soulful. I can proudly say that the decision to study at Vaish College was my life's and career's best decision.",
      image: 'assets/img/testimonials/heena.jpg'
    }
  ];

  constructor() { }

  ngOnInit(): void {
  }

  next(): void {
    this.activeStartIndex = (this.activeStartIndex + 1) % this.testimonials.length;
  }

  prev(): void {
    this.activeStartIndex = (this.activeStartIndex - 1 + this.testimonials.length) % this.testimonials.length;
  }

}
